import Events from '@/shared/ipcUtils/Events'
import { AxiosInstance } from 'axios'

const NOTE_POLLING_TAG = '[NotePolling]'

type WorkspaceEtagListener = (etag: string) => void
const workspaceEtagListeners = new Set<WorkspaceEtagListener>()

export function onWorkspaceEtagObserved(listener: WorkspaceEtagListener): () => void {
  workspaceEtagListeners.add(listener)
  return () => workspaceEtagListeners.delete(listener)
}

function emitWorkspaceEtag(etag: string) {
  for (const listener of workspaceEtagListeners) {
    try {
      listener(etag)
    } catch (error) {
      console.warn(`${NOTE_POLLING_TAG} etag_listener_failed`, error)
    }
  }
}

function extractWorkspaceEtag(headers: any): string | null {
  if (!headers) return null
  const direct = headers['workspace-etag'] ?? headers['Workspace-ETag']
  if (typeof direct !== 'string' || direct.length === 0) return null
  return direct
}

export function installWorkspaceEtagInterceptor(
  axios: AxiosInstance,
  options?: { forwardToMain?: boolean }
) {
  const shouldForwardToMain = options?.forwardToMain === true
  axios.interceptors.response.use((response) => {
    const workspaceEtag = extractWorkspaceEtag(response.headers)
    if (!workspaceEtag) return response

    emitWorkspaceEtag(workspaceEtag)

    if (shouldForwardToMain) {
      try {
        if (typeof window !== 'undefined' && window.mainApi?.send) {
          window.mainApi.send(Events.Calendar.WORKSPACE_ETAG_OBSERVED, workspaceEtag)
        }
      } catch {
        // ignore in runtimes without main IPC bridge
      }
    }

    return response
  })
}
